'use strict';
/**
 * @author Maxim Seredkin
 */
export default function () {
    return {
        restrict: 'A',
        template: require('../view/project-tab-maintenances.html'),
        controller: ['$scope', 'PStatusRestService', '$uibModal',
            function ($scope, PStatusRestService, $modal) {
                $scope.selectMaintenanceKind = {
                    id: 1,
                    name: "Одно окно",
                    status: "ENABLED"
                };

                $scope.equals = equals;
                $scope.changeStatus = changeStatus;
                $scope.updateDate = updateDate;

                PStatusRestService.get(null, (data) => {
                    $scope.projectStatuses = data._embedded;
                });

                function updateDate() {
                    $scope.project.projectStatus.transitionDate = new Date();
                    $scope.project.projectStatus.comment = '';
                }
                // region Function
                function changeStatus() {
                    $modal.open({
                        template: require('../module/progress/view/project-status-modal-change.html'),
                        controller: 'ProjectStatusModalChangeController',
                        size: 'md',
                        backdrop: false,
                        resolve: {
                            status: function () {
                                return $scope.project.projectStatus != null ? $scope.project.projectStatus : {transitionDate: new Date()};
                            },
                            pStatuses: function () {
                                let pStatuses = angular.copy($scope.projectStatuses);
                                // удаляем текущий статус из списка
                                // if ($scope.project.projectStatus != null && $scope.project.projectStatus.status != null && $scope.project.projectStatus.status.id !== null)
                                //     pStatuses.splice(pStatuses.indexOf(pStatuses.find(status => status.id == $scope.project.projectStatus.status.id)), 1);
                                return pStatuses;
                            }
                        }
                    }).result.then(function (data) {
                        $scope.project.projectStatus = data;
                    });

                }

                function groupBy(xs, key) {
                    return xs.reduce(function (rv, x) {
                        (rv[x[key]] = rv[x[key]] || []).push(x);
                        return rv;
                    }, {});
                }

                function equals(a, b) {
                    return angular.equals(a, b);
                }

                // endregion

                // region Watcher

                $scope.$watch('project.projectStatus.status.id', (current) => {
                    if (Array.isArray($scope.projectStatuses)) {
                        let status = $scope.projectStatuses.find(status => status.id == current);
                        if (status != null) {
                            if ($scope.project.projectStatus != null) {
                                $scope.project.projectStatus.status = status;
                            } else {
                                $scope.project.projectStatus = {status: status};
                            }
                        }
                    }
                });

                // endregion

            }]
    };
}